import CallRoutingConfigurationForm from "./CallRoutingConfigurationForm.component.jsx";

export default CallRoutingConfigurationForm;
